import request from '@/api';

export interface ITemplate {
  coverUrl: string;
  name: string;
  isCollect: number;
  // 添加其他模板相关的属性
}

// 获取模板列表 
export const fetchTemplates = (data: any) => {
  return request.post('/app/videoTemplate/getAppVideoTemplatePage', data);
};

// 获取数字人列表
export const fetchVirtualManList = (data: any) => {
  return request.post('/app/virtualManTencent/getAppVirtualManTencentPage', data);
};


// 获取音色列表
export const fetchVoiceList = (data: any) => {
  return request.post('/app/timbre/getAppTimbrePage', data);
};


// 收藏
export const fetchCollect = (data: any) => {
  return request.post('/app/userCollect/appUserCollect', data);
};

//创建视频
export const fetchCreateVideo = (data: any) => {
  return request.post('/app/video/createVideoByTemplate', data);
};

// 计算积分
export const fetchCalculateIntegral = (data: any) => {
  return request.post('/app/video/calculatePoint', data);
};

// 获取视频模板详情
export const fetchAppVideoTemplate = (id: number | string) => {
  return request.post(`/app/videoTemplate/getAppVideoTemplate/${id}`);
};


